var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { BaseChartStyles } from '../Charts/Charts.styles';
import { color } from '../../../constants';
export var XAxisBase = styled.g(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n\n  .XAxis--TickMark {\n    stroke-width: 1px;\n  }\n"], ["\n  ", "\n\n  .XAxis--TickMark {\n    stroke-width: 1px;\n  }\n"])), BaseChartStyles);
export var XAxisTick = styled.text(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  fill: ", " !important;\n"], ["\n  fill: ",
    " !important;\n"])), function (props) {
    return props.isWeekend
        ? color.theme.typography.subdued
        : color.theme.typography.ink;
});
var templateObject_1, templateObject_2;
//# sourceMappingURL=XAxis.styles.js.map